import Modal from 'bootstrap/js/dist/modal';

function NewsletterWidget()
{
    const signupForm = document.getElementById('widget-newsletter-signup-form');
    const signupModalElement = document.getElementById('widget-newsletter-signup-modal');
    const signupModal = (signupModalElement !== null) ? Modal.getOrCreateInstance(signupModalElement) : null;
    const emailInput = document.getElementById('widget-newsletter-input-email');
    const modalEmailInput = (signupModalElement !== null) ? signupModalElement.querySelector('input[type="email"]') : null;
    const firstTextInput = (signupModalElement !== null) ? signupModalElement.querySelector('input[type="text"]') : null;

    if (signupForm === null) {
        return;
    }

    // Newsletter modal - Show on form submit and copy email
    signupForm.addEventListener('submit', event => {
        event.preventDefault();
        if (emailInput !== null && emailInput.value) {
            signupModal.show();
            // Copy the email to the modal input
            modalEmailInput.value = emailInput.value;
        }
    });

    
    // Newsletter modal - Focus first text field in modal when shown
    signupModalElement.addEventListener('shown.bs.modal', event => {
        firstTextInput.focus();
    });
}

export default NewsletterWidget;
